define(function(require) {
	const Marionette = require('backbone.marionette');
	require('remodal');
	//
	// 2016-03-10 CV:   Remove the .css references before going live
	//                  And potentially the require('remodal')
	
	return Marionette.Region.extend({
		inst:null,
		focusSave: null,
		//make sure to set the el attribute when using, or else it won't have a dom element to place itself in
		constructor:function(){
			_.bindAll(this);
			Marionette.Region.prototype.constructor.apply(this,arguments);
			this.on('show',this.initializeModal,this);
			$(document).on('closed', '.remodal', this.onCloseModal);
		},
		getEl:function(selector){
			var $el = $(selector);
			return $el;
		},
		initializeModal:function(view){
			this.inst = this.$el.remodal({
				modifier:'rhy bbm-wrapper',
				closeOnOutsideClick:false
			});
			this.$el.css({'animation-duration':'.25s'});
			view.on('destroy',this.hideModal,this);
			$(document).on('closed', '.remodal', this.hideModal);
			this.currentView = view;
			this.showModalPromise = $.Deferred();

		},
		onModalScroll: function(el)
		{
			//hide calendar picker on modal scroll
			el.on('wheel scroll', function(e){
				if (el.find('.datetimepicker').hasClass('focus-form')){
					el.find('.civics-datepicker').blur();
				}
				$('.bbm-modal').off('wheel scroll');
			});
		},
		showModal:function(){
			var self = this;
			// Set the variable for the link or button that activated the modal
			self.focusSave = document.activeElement;
			self.inst.open();
			setTimeout(function(){
				self.showModalPromise.resolve();
				self.trapFocus(self.$el);
				self.onModalScroll(self.$el);
				}.bind(self), 260);//slightly longer than the animation duration CSS
		},
		hideModal:function(callback){
			$(document).off('closed', '.remodal', this.hideModal);
			if(this.inst.state!='closed') {
				this.inst.close();
			}
			this.onCloseViewCallback = (typeof callback === 'function') ? callback : null;

			if(this.$el){
				this.$el.css('max-width','');
			}

			// Set the focus back to the current element that activated the Modal
			if(this.focusSave != null && $(this.focusSave).not(":hidden").length > 0) {
				$(this.focusSave).focus();
			}
		},
		onCloseModal: function() {
			if(this.currentView) {
				// Set the focus back to the current element that activated the Modal
				if(this.focusSave != null && $(this.focusSave).not(":hidden").length > 0) {
					$(this.focusSave).focus();
				}
				if(this.onCloseViewCallback) {
					setTimeout(this.onCloseViewCallback, 260);//slightly longer than the animation duration CSS, so if we're opening a modal one after another, they won't conflict.
				}
				if(this.currentView.options && this.currentView.options.onCloseViewCallback) {
					setTimeout(this.currentView.options.onCloseViewCallback, 260);
				}
				if(this.currentView?.config && !this.currentView.config.preventDestroy){//callback might destroy view. need to check after calling callback
					this.currentView.destroy();
				}
			}
			if (this.closeModalPromise) {
				this.closeModalPromise.resolve();
				this.closeModalPromise = null; // Reset for next time
			}			

		},
		trapFocus: function(el) {
			// On tab key down, check if it's the first or last item, then move the focus correctly
  		el.on('keydown', 'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, div[tabindex="0"]', function(e) {
        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

        if (!isTabPressed) {
            return;
        }

	    	var focusableEls = el.find('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, div[tabindex="0"]').not(":hidden");
				$(".firstFocusable, .lastFocusable").removeClass("firstFocusable").removeClass("lastFocusable");
	      focusableEls.eq(0).addClass("firstFocusable");
	      focusableEls.eq(focusableEls.length - 1).addClass("lastFocusable");

        if ( e.shiftKey ) /* shift + tab */ {
          if ((document.activeElement.className).indexOf("firstFocusable") > -1) {
            el.find(".lastFocusable").focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if ((document.activeElement.className).indexOf("lastFocusable") > -1) {
            el.find(".firstFocusable").focus();
            e.preventDefault();
          }
        }
	    });
		}
	});
});
